{
  "CONTACTS_FILTER": {
    "TITLE": "Filtrar Contatos",
    "SUBTITLE": "Adicione filtros abaixo e clique em 'Enviar' para filtrar conversas.",
    "EDIT_CUSTOM_SEGMENT": "Alterar segmento",
    "CUSTOM_VIEWS_SUBTITLE": "Adicione ou remova filtros e atualize seu segmento.",
    "ADD_NEW_FILTER": "Adicionar filtro",
    "CLEAR_ALL_FILTERS": "Limpar Filtros",
    "FILTER_DELETE_ERROR": "Você deve ter pelo menos um filtro para salvar",
    "SUBMIT_BUTTON_LABEL": "Enviar",
    "UPDATE_BUTTON_LABEL": "Atualizar segmento",
    "CANCEL_BUTTON_LABEL": "Cancelar",
    "CLEAR_BUTTON_LABEL": "Limpar Filtros",
    "EMPTY_VALUE_ERROR": "Valor obrigatório",
    "SEGMENT_LABEL": "Nome do segmento",
    "SEGMENT_QUERY_LABEL": "Consulta de Segmento",
    "TOOLTIP_LABEL": "Filtrar contatos",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "E",
      "OR": "OU"
    },
    "OPERATOR_LABELS": {
      "equal_to": "Igual a",
      "not_equal_to": "Não igual a",
      "contains": "Contém",
      "does_not_contain": "Não contém",
      "is_present": "Está presente",
      "is_not_present": "Não está presente",
      "is_greater_than": "É maior que",
      "is_lesser_than": "É menor que",
      "days_before": "É x dias antes"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Valor obrigatório"
    },
    "ATTRIBUTES": {
      "NAME": "Nome",
      "EMAIL": "E-mail",
      "PHONE_NUMBER": "Número de telefone",
      "IDENTIFIER": "Identificador",
      "CITY": "Cidade",
      "COUNTRY": "País/região",
      "CUSTOM_ATTRIBUTE_LIST": "Lista",
      "CUSTOM_ATTRIBUTE_TEXT": "Texto",
      "CUSTOM_ATTRIBUTE_NUMBER": "Número",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Checkbox",
      "CREATED_AT": "Criado em",
      "LAST_ACTIVITY": "Última atividade",
      "REFERER_LINK": "Link de origem",
      "BLOCKED": "Bloqueado",
      "LABELS": "Etiquetas"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Filtros Padrão",
      "ADDITIONAL_FILTERS": "Filtros adicionais",
      "CUSTOM_ATTRIBUTES": "Atributos Personalizados"
    }
  }
}
